import { ApprovalsTasksResponse } from '@Types/api/approvalsList/ApprovalsListResponse';
import { parseDateTime } from '@Utils/transformDateTime';
import { TypeDict } from '@Types/index';

import { ColumnDataType } from './type';

const DATE_FORMAT = 'DD/MM/YYYY [at] hh:mm A';

export const dataSourceMap = (
  data: ApprovalsTasksResponse[],
  findRequestTypeBy: (
    criteria: string | number,
    searchBy: 'codeDesc' | 'codeNum' | 'code'
  ) => TypeDict
): Array<ColumnDataType> => {
  return data?.map((taskData) => {
    return {
      key: taskData.taskId,
      taskData,
      taskId: taskData.taskId,
      created: parseDateTime(taskData.created, DATE_FORMAT),
      requestId: taskData.requestId,
      requestTypeId: findRequestTypeBy(taskData.requestTypeId, 'codeNum')
        ?.codeDesc,
      employeeName: taskData.employeeName,
      employeeOccupation: taskData.occupation,
      company: taskData.companyName,
      lastUpdated: parseDateTime(taskData.updated, DATE_FORMAT),
      statusId: taskData.statusId,
      action: '',
    };
  });
};
